import { gql } from "@apollo/client";

export const AddSiteMutation = gql `
mutation($input: createSiteInput!){
    createSite(input: $input) {
      response
      message
    }
}
`;

export const UpdateBulkSiteMutation = gql `
mutation($input: BulkSiteUpdateInput!){
    updateBulkSite(input: $input) {
      response
      message
    }
}
`;

export const UpdateSingleSiteMutation = gql `
mutation($input: SiteUpdateInput!){
  updateSite(input: $input) {
    success
    response
    message
  }
}
`;

export const RestoreSiteMutation = gql `
mutation($siteId: String!){
    restoreSite(siteId: $siteId) {
      response
      message
    }
}
`;

export const MergeSitesMutation = gql `
mutation($input: MergeSitesInput!){
    mergeSites(input: $input) {
      success
      message
      response
    }
}
`;